import { Phone, EnvelopeSimple, MapPin } from '@phosphor-icons/react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="footer" className="bg-secondary-bg border-t border-border-subtle">
      {/* Main Footer */}
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-6 mb-6">
              <img 
                src="/rimsie-logo-final.png"
                alt="Rimsie Constructions Pty Ltd"
                className="h-14 w-auto"
              />
              <img 
                src="/master-builders.jpg"
                alt="Master Builders Association Member"
                className="h-14 w-auto"
              />
            </div>
            <p className="text-body-text leading-relaxed max-w-md mb-6">
              Licensed builder delivering quality commercial and residential builds across 
              the NSW Central Coast. Brett Rimmer coordinates every project hands-on.
            </p>
            <div className="flex flex-col gap-2 text-sm text-body-muted">
              <p>Lic. 359294C</p>
              <p>ABN: 71 639 164 248</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-heading font-heading text-lg mb-6">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              {[
                { label: 'About', href: '#about' },
                { label: 'Services', href: '#services' },
                { label: 'Projects', href: '#gallery' },
                { label: 'Process', href: '#process' },
                { label: 'Blog', href: '#blog' },
                { label: 'Contact', href: '#contact' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="text-body-text hover:text-heading transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-heading font-heading text-lg mb-6">Contact</h4>
            <div className="space-y-4">
              <a 
                href="tel:0416283443" 
                className="flex items-center gap-3 text-body-text hover:text-heading transition-colors"
              >
                <Phone size={18} className="text-accent" />
                0416 283 443
              </a>
              <a 
                href="mailto:rimsieconstructions@hotmail.com" 
                className="flex items-center gap-3 text-body-text hover:text-heading transition-colors"
              >
                <EnvelopeSimple size={18} className="text-accent" />
                Email Us
              </a>
              <div className="flex items-start gap-3 text-body-text">
                <MapPin size={18} className="text-accent mt-1 flex-shrink-0" />
                <span>
                  16/4 Colony Close<br />
                  Tuggerah NSW 2261
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-border-subtle">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-body-muted">
            <p>
              © {currentYear} Rimsie Constructions Pty Ltd. All rights reserved.
            </p>
            <p>
              Built with care on the Central Coast
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
